import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '@app/shared/services';
import { environment } from '@environments/environment';
import { ResponseResult } from '@app/auth/model';

@Injectable({
  providedIn: 'root',
})
export class StudentFeedbackService extends BaseService {
  private customEndpointPrefix: string;

  constructor(private http2: HttpClient) {
    super(http2, 'admin', 'StudentFeedback');
    this.customEndpointPrefix = `${environment.urlAPI}/admin/StudentFeedback`;
  }

  getByStudentClassesCourseId(studentClassesCourseId: number): any {
    return this.http2.get<ResponseResult>(
      `${this.customEndpointPrefix}/studentClassesCourse/${studentClassesCourseId}`
    );
  }

  getByStudentId(studentId: number): any {
    return this.http2.get<ResponseResult>(
      `${this.customEndpointPrefix}/student/${studentId}`
    );
  }
}
